var _style, _defs, _defs2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSenai(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150.3 50",
    style: {
      enableBackground: "new 0 0 150.3 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_00000023983815324687491830000007199391736252257694_);fill:#FF0000;}\r\n\t.st1{clip-path:url(#SVGID_00000023983815324687491830000007199391736252257694_);fill:#FFFFFF;}\r\n\t.st2{clip-path:url(#SVGID_00000023983815324687491830000007199391736252257694_);}\r\n\t\r\n\t\t.st3{clip-path:url(#SVGID_00000106850846452976518210000010552297411582049413_);fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "SENAI_x5F_rgb_00000115493807487861116970000009001315340226369923_"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 9.1,
    y: 8.2,
    width: 132,
    height: 33.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000137123638360226141170000004942831359464362425_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 9.1,
    y: 8.2,
    style: {
      clipPath: "url(#SVGID_00000137123638360226141170000004942831359464362425_)",
      fill: "#FF0000"
    },
    width: 132,
    height: 33.7
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000137123638360226141170000004942831359464362425_)",
      fill: "#FFFFFF"
    },
    d: "M9.1,37h7.1v-0.9H9.1 V37z M9.1,31.3h7.1v-0.9H9.1V31.3z M9.1,25.4h7.1v-0.9H9.1V25.4z M9.1,19.6h7.1v-0.9H9.1V19.6z M9.1,13.9h7.1v-0.9H9.1V13.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000137123638360226141170000004942831359464362425_)",
      fill: "#FFFFFF"
    },
    d: "M134.1,37h7v-0.9h-7 V37z M134.1,31.3h7v-0.9h-7V31.3z M134.1,25.4h7v-0.9h-7V25.4z M134.1,19.6h7v-0.9h-7V19.6z M134.1,13.9h7v-0.9h-7V13.9z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000137123638360226141170000004942831359464362425_)"
    }
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000000211954421611283780000014124835216206436532_",
    x: 9.1,
    y: 8.2,
    width: 132,
    height: 33.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000044140516143670672520000017642187130043822239_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000000211954421611283780000014124835216206436532_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000044140516143670672520000017642187130043822239_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    },
    d: " M126.5,37l5.1-24h-6.7l-5.1,24H126.5z M102.1,27.6l5.4-10h0.1l0.9,10H102.1z M96.9,37l2.6-4.7h9.8l0.6,4.7h7.5l-4.4-24h-8.1 L90.2,37H96.9z M64.3,37h6l3.9-18.4h0.1L78.5,37h9.2l5.1-24h-6l-3.8,17.8L83,30.9L78.7,13h-9.3L64.3,37z M60.6,37l1-4.7H49.9 l1.1-5.1h10.7l1-4.7H52l1.1-5h11.6l1-4.7H47.4l-5.1,24H60.6z M41.3,20c1.6-5.8-3.1-7.6-8-7.6c-5,0-10.4,1.6-11.8,7.3 c-0.5,2.6,0.2,4.8,2.4,5.9c4.7,2.3,9.8,1.6,9.1,4.9c-0.3,1.6-2.5,2.4-4,2.4c-2.4,0-3.8-1.2-3.3-3.5H19c-1.3,6.5,3.3,8.2,8.9,8.2 c5.6,0,11.1-2.4,12.1-7.5c1.4-6.5-4.4-6.9-8.2-7.9c-1.7-0.5-3.7-1-3.3-2.8c0.3-1.2,1.8-2.2,3.3-2.2c1.1,0,1.9,0.3,2.4,0.8 c0.5,0.5,0.6,1.2,0.4,2.1H41.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSenai);
export default __webpack_public_path__ + "static/media/senai.bbb1d42f597377a223dd4f5306e7fba5.svg";
export { ForwardRef as ReactComponent };